var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.8125C0 7.3981 0.16462 7.00067 0.457646 6.70764C0.750671 6.41462 1.1481 6.25 1.5625 6.25H17.1812C20.4437 6.25 23.3167 7.91667 24.9958 10.4458C25.8504 9.1548 27.0117 8.09578 28.3758 7.36355C29.7399 6.63132 31.2643 6.24872 32.8125 6.25H48.4375C48.8519 6.25 49.2493 6.41462 49.5424 6.70764C49.8354 7.00067 50 7.3981 50 7.8125V39.1938C49.9995 39.3997 49.9583 39.6035 49.8789 39.7935C49.7996 39.9835 49.6835 40.156 49.5374 40.3011C49.3914 40.4462 49.2181 40.5611 49.0276 40.6392C48.837 40.7173 48.633 40.7571 48.4271 40.7563L32.4229 40.6479C31.595 40.642 30.7742 40.8007 30.0081 41.1147C29.2421 41.4287 28.546 41.8918 27.9604 42.4771L26.1062 44.3333C25.9611 44.4785 25.7889 44.5937 25.5992 44.6723C25.4096 44.7509 25.2063 44.7913 25.001 44.7913C24.7958 44.7913 24.5925 44.7509 24.4029 44.6723C24.2132 44.5937 24.0409 44.4785 23.8958 44.3333L22.0167 42.4563C21.4367 41.8755 20.7479 41.4148 19.9897 41.1006C19.2314 40.7863 18.4187 40.6247 17.5979 40.625H1.5625C1.1481 40.625 0.750671 40.4604 0.457646 40.1674C0.16462 39.8743 0 39.4769 0 39.0625L0 7.8125ZM26.5625 39.5458C28.2359 38.2224 30.3103 37.5089 32.4437 37.5229L46.875 37.6208V9.375H32.8125C31.1549 9.375 29.5652 10.0335 28.3931 11.2056C27.221 12.3777 26.5625 13.9674 26.5625 15.625V39.5458ZM23.4312 15.6188C23.4296 13.9622 22.7704 12.3741 21.5985 11.2034C20.4265 10.0326 18.8378 9.375 17.1812 9.375H3.125V37.5H17.5979C19.7187 37.5 21.7771 38.2208 23.4375 39.5417L23.4312 15.6188Z",
    fill: "#1731AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.3ae7826220e16eaf5b95697122cd0fd6.svg";
export { ForwardRef as ReactComponent };